import React from 'react'
import styled from 'styled-components'
import OverviewBG from '../../../../assets/bg/pc/bg_overview.png'

const OverviewPCComponent = () => {
  return (
    <Wrap>
      <img src={OverviewBG} />
    </Wrap>
  )
}

export default OverviewPCComponent

const Wrap = styled.div`
  margin-top: -10%;
  z-index: 10;
`
